import { render, staticRenderFns } from "./GatewayInfo.global.vue?vue&type=template&id=335c3f88&scoped=true&lang=html&"
import script from "./GatewayInfo.global.vue?vue&type=script&lang=ts&"
export * from "./GatewayInfo.global.vue?vue&type=script&lang=ts&"
import style0 from "./GatewayInfo.global.vue?vue&type=style&index=0&id=335c3f88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335c3f88",
  null
  
)

export default component.exports